import { apiRequest } from '../../services/apiClient';

// TPRM first-pass criteria (structured JSON policy) — GET reviewer, PUT legal.
export function getTprmCriteria() {
  return apiRequest('/tprm/review-criteria');
}

export function updateTprmCriteria({ criteria, name, version }) {
  return apiRequest('/tprm/review-criteria', {
    method: 'PUT',
    json: { criteria, name, version },
  });
}

// Key-term criteria (risks / commitments / financial terms, by type+category) —
// same GET-reviewer / PUT-legal gating.
export function getKeyRiskCriteria() {
  return apiRequest('/key-risk/criteria');
}

export function updateKeyRiskCriteria({ criteria, name, version }) {
  return apiRequest('/key-risk/criteria', {
    method: 'PUT',
    json: { criteria, name, version },
  });
}
